import Auth from "config/auth";
import { setClientSettingsFromLogin } from "utils/client-settings";
import getDefaultRoute from "utils/getDefaultRoute";
import ROLES from "@constants/roles";

const {
  AGENCY_ADMIN,
  AGENCY_SUPER_OPERATOR,
  AGENCY_USER,
  CLIENT_USER,
  FINANCE_USER,
  SYSTEM_ADMIN,
} = ROLES;

const rolePriority = [
  AGENCY_ADMIN,
  AGENCY_USER,
  FINANCE_USER,
  CLIENT_USER,
  SYSTEM_ADMIN,
  AGENCY_SUPER_OPERATOR,
];

export const REMEMBERED_USERNAME_KEY = "rememberedUsername";

export const getRememberedUsername = () => {
  return localStorage.getItem(REMEMBERED_USERNAME_KEY) || "";
};

export const setRememberedUsername = username => {
  localStorage.setItem(REMEMBERED_USERNAME_KEY, username);
};

export const clearRememberedUsername = () => {
  localStorage.removeItem(REMEMBERED_USERNAME_KEY);
};

export const sortUserRolesByPriority = (roles = []) => {
  return [...roles].sort((roleA, roleB) => {
    return rolePriority.indexOf(roleA?.RoleName) - rolePriority.indexOf(roleB?.RoleName);
  });
};

export const persistLoginSession = (responseData, remember) => {
  const payload = {
    resultData: responseData
  };

  const rolePayload = {
    userRoles: payload.resultData?.existingSystemRoles
  };

  localStorage.setItem("eUserRoles", JSON.stringify(rolePayload));
  localStorage.setItem("loggedInUser", JSON.stringify(responseData));

  // set client settings from login response data
  setClientSettingsFromLogin(responseData);
  
  const { roles = [], sessionKey, user = {} } = responseData || {};

  Auth.set("rememberMe", remember);
  Auth.setSessionKey(sessionKey);

  const { ObjectId: userObjectId, Username: userName } = user;
  const userRoles = roles.map(({ ObjectId, RoleName }) => ({ ObjectId, RoleName }));
  const currentUserRole = sortUserRolesByPriority(userRoles)[0]?.RoleName || null;

  Auth.storeSessionDetails({
    currentUserRole,
    userName,
    userObjectId,
    userRoles
  });

  return {
    currentUserRole,
    navigateTo: getDefaultRoute(currentUserRole),
    sessionKey
  };
};

export const getAuthenticatedRoute = () => {
  const { currentUserRole } = Auth.getSessionDetails() || {};

  if (Auth.isAuthenticated() && currentUserRole) {
    return getDefaultRoute(currentUserRole);
  }

  return null;
};